var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var actions = require( '../../../modules/posts/actions/postList');
var postActions = require( '../../../modules/posts/actions/post');
var PostList = require('../components/postList.jsx');
var postUtils = require( '../../../modules/posts/postUtils');

  PostList.fetchData = function(query, params, store, history) {
      var digestedParams = postUtils.digestParams(params);

      return store.dispatch(actions.fetchPostListIfNeeded(digestedParams.categorySlug, digestedParams.pageNum));
  }

  var mapStateToProps = function(state, ownProps){
    var digestedParams = postUtils.digestParams(ownProps.params);
    var postListCacheSlug = postUtils.getPostListCacheSlug(digestedParams.categorySlug, digestedParams.pageNum);

    return {
      postList: state.postList[postListCacheSlug] || {
          isFetching: false,
          data: {},
          error: {}
      },
      categories: state.postList.categories
    };
  }

  var mapDispatchToProps = function(dispatch) {
    return bindActionCreators(Object.assign({}, actions, postActions), dispatch);
  }

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(PostList);



// WEBPACK FOOTER //
// ./src/common/routes/posts/containers/postList.jsx